import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EMPTY_RICH_TEXT_DOCUMENT, richTextDocumentHasContent, } from "@diality/contracts";
import { RichTextDocumentView } from "./rich-text";
import { Button } from "../components/ui/button";
import { Reveal } from "../components/ui/reveal";
import { BlockLink } from "../render/context";
/** Split promotional endcap used below the careers list. */
export function Promo2ColumnView({ data }) {
    return (_jsxs("section", { className: "grid w-full max-w-[1132px] grid-cols-1 items-start gap-7 @min-[901px]:grid-cols-[minmax(0,491px)_minmax(0,487px)] @min-[901px]:justify-between @min-[901px]:gap-20", children: [_jsx(Reveal, { children: _jsx("h2", { className: "m-0 w-full max-w-[491px] text-balance font-display text-brand-blue text-[clamp(44px,13cqw,56px)] font-light leading-[1.04] tracking-[-0.02em] @min-[901px]:text-[64px]", children: data.title }) }), _jsxs(Reveal, { delay: 0.1, className: "flex flex-col items-start gap-4", children: [richTextDocumentHasContent(data.description) ? (_jsx(RichTextDocumentView, { document: data.description, className: "w-full max-w-[487px] text-[17px] font-light leading-[1.55] @min-[901px]:text-xl [&_p]:my-0 [&_p]:leading-[1.55] [&_p+p]:mt-4" })) : null, data.cta.label && data.cta.href ? (_jsx(Button, { asChild: true, children: _jsx(BlockLink, { href: data.cta.href, children: data.cta.label }) })) : null] })] }));
}
export function Promo2ColumnBlock({ data }) {
    return (_jsx("div", { className: "flex w-full justify-center px-m-gutter @min-[901px]:px-[62px]", children: _jsx(Promo2ColumnView, { data: data }) }));
}
export function promo2ColumnFromBlock(block, _resolve) {
    return {
        title: block.scalars?.title ?? "",
        description: block.documents?.description ?? EMPTY_RICH_TEXT_DOCUMENT,
        cta: {
            label: block.scalars?.ctaLabel ?? "",
            href: block.scalars?.ctaHref ?? "",
        },
    };
}
export const promo2ColumnBlockEntry = {
    Component: Promo2ColumnBlock,
    fromBlock: promo2ColumnFromBlock,
};
//# sourceMappingURL=promo-2-column.js.map